const Logo = (props) => {
  const { size = 1 } = props
  const width = `${Math.ceil(19 * size)}`
  const height = `${Math.ceil(19 * size)}`

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.45" filter="url(#filter0_b_12863_47819)">
        <circle cx="9.5" cy="9.5" r="9.5" fill="#1F1F1F" />
      </g>
      <path
        d="M6.47656 6.47705L12.522 12.5225M6.47656 12.5225L12.522 6.47705L6.47656 12.5225Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="filter0_b_12863_47819"
          x="-4"
          y="-4"
          width="27"
          height="27"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_12863_47819"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_12863_47819"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default Logo
